import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { sendPasswordRetrieveRequest } from '../../../services/password-retrieve.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../services/error-message.service';

// Props d'entrée de la fonction ForgetPasswordDialog
type Props = {
    open: boolean;
    handleClose: any;
};

/**
 * Compsant qui permet de gérer le mot de passe perdu
 * @param open permet de savoir si la popup est ouverte
 * @param handleClose handle sur le close
 * @constructor
 */
function ForgetPasswordDialog({ open, handleClose }: Props) {
    //SnackBar pour les messages
    const showMessage = useSnackbars();

    //Use state
    const [validate, setValidate] = useState(false);

    //Handle submit qui permet de faire un traitement à la validation du formulaire
    const handlerSubmit = (e: { login: string }) => {
        // Empêche de pouvoir submit pendant le traitement
        setValidate(true);
        //Permet d'envoyer un lien pour la réinitialisation de mot de passe
        sendPasswordRetrieveRequest(e)
            .then(data => {
                showMessage.successAlert(data.message);
                handleClose();
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setValidate(false);
            });
    };

    //Initialisation des valeurs
    const iniValues = {
        login: '',
    };

    return (
        //Retourne la vue popup
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle variant={'h5'} style={{ marginBottom: '0px' }}>
                Mot de passe oublié
            </DialogTitle>
            <Formik initialValues={iniValues} onSubmit={handlerSubmit}>
                <Form>
                    <>
                        <DialogContent>
                            <DialogContentText variant={'body1'} style={{ marginBottom: '20px' }}>
                                Veuillez entrer votre identifiant pour demander la réinitialisation de votre mot de
                                passe. Un lien avec des instructions vous sera envoyé.
                            </DialogContentText>
                            <InputForm autoFocus id="login" name="login" label="Identifiant" type="email" required />
                        </DialogContent>
                        <DialogActions>
                            <Typography variant={'button'}>
                                <Button variant="neutral" onClick={handleClose}>
                                    Annuler
                                </Button>
                            </Typography>
                            <Typography variant={'button'}>
                                <Button type="submit" variant="contained" disabled={validate}>
                                    Valider
                                </Button>
                            </Typography>
                        </DialogActions>
                    </>
                </Form>
            </Formik>
        </Dialog>
    );
}

export default ForgetPasswordDialog;
